import { createContext, useContext } from 'react';

// Card provides `true`. Form fields (text inputs, numbers, selectors) are filled
// with the card colour on the page canvas; inside a Card that fill would match
// the card, so there they use the canvas colour instead.
export const OnCardContext = createContext(false);

export const useIsOnCard = () => useContext(OnCardContext);
